<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVrijstellingen">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseVrijstellingen" aria-expanded="false"
                    aria-controls="collapseVrijstellingen">
                Vrijstellingen
            </button>
        </h2>
        <div id="collapseVrijstellingen" class="accordion-collapse collapse" aria-labelledby="headingVrijstellingen"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De schenkbelasting kent verschillende vrijstellingen. Er zijn jaarlijkse vrijstellingen en verhoogde
                vrijstellingen. Voorwaarden betreffen o.a. leeftijd van de begiftigde, bestemming van het geschonken
                bedrag, en schriftelijke vastlegging. Niet tijdig benutten of verkeerd toepassen van een vrijstelling
                leidt tot verlies van het voordeel. Sommige vrijstellingen mogen slechts één keer in het leven benut
                worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBasis">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBasis" aria-expanded="false"
                    aria-controls="collapseVBasis">
                Basisvrijstelling
            </button>
        </h2>
        <div id="collapseBasis" class="accordion-collapse collapse" aria-labelledby="headingBasis"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Tot welk bedrag is een schenking belastingvrij in 2025?</b><br/>
                Dat hangt af van de relatie tussen schenker en ontvanger. En van het doel waarvoor het geld wordt
                gebruikt. We hebben de meest voorkomende schenkingsvrijstellingen 2025 op een rij gezet.

                <b>Jaarlijkse basisvrijstelling</b><br/>
                Ouders mogen in 2025 € 6.713 schenken aan hun kind. Onder 'kind' verstaan ww ook een pleegkind of een
                stiefkind.<br/>
                De jaarlijkse vrijstelling voor alle andere personen in 2025 is € 2.690. Het maakt bij die schenking dus
                niet uit of de schenker een grootouder is, een oom of een tante, broer of zus of helemaal geen familie.
                De ontvanger betaalt bij schenkingen tot de jaarlijkse vrijstelling geen schenkbelasting en hoeft geen
                aangifte te doen.

                <div class="space20"></div>
                Partners, zoals ouders of grootouders, ziet de Belastingdienst als 1 schenker. Als partners allebei een
                schenking
                krijgen van dezelfde schenker, telt dit als 1 schenking.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB2" aria-expanded="false" aria-controls="collapseB2">
                Eenmalig verhoogde vrijstelling voor kinderen
            </button>
        </h2>
        <div id="collapseB2" class="accordion-collapse collapse" aria-labelledby="headingB2"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                Kinderen van 18 tot en met 39 jaar kunnen éénmalig een verhoogde vrijstelling van <b>€ 33.129</b> (2026)
                krijgen van hun ouders. De dag van de 40e verjaardag telt nog mee. Deze vrijstelling geldt voor een
                schenking zonder bijzondere bestemming. De leeftijdsgrens mag worden verruimd als de partner van het
                kind nog geen 40 is. De vrijstelling moet expliciet worden gemeld in de aangifte.

                <div class="space20"></div>
                Voorwaarde is ook dat het kind niet eerder een verhoogde vrijstelling heeft gebruikt voor een schenking van
                de ouder(s). Hiermee bedoelen we een belastingvrije schenking voor de eigen woning óf een belastingvrije
                schenking voor een dure studie óf een belastingvrije schenking voor een vrij te besteden doel.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB3" aria-expanded="false" aria-controls="collapseB3">
                Verhoogde vrijstelling voor studie
            </button>
        </h2>
        <div id="collapseB3" class="accordion-collapse collapse" aria-labelledby="headingB3"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                Deze eenmalige vrijstelling geldt voor kinderen (18–39 jaar) als de schenking wordt gebruikt voor een
                dure studie. De vrijstelling bedraagt in 2025 maximaal <b>€ 66.268</b>. De studie moet aantoonbaar
                minstens € 20.000 per jaar kosten en opleiden tot een toekomstig beroep. De vrijstelling moet worden
                gekozen in de aangifte en mag niet gecombineerd worden met andere verhoogde vrijstellingen.

                <div class="space20"></div>
                De voorwaarden voor deze vrijstelling zijn:<br/>
                <ul>
                    <li>
                        De ontvanger is een kind van de schenker. Onder 'kind' verstaan wij ook een pleegkind of een
                        stiefkind.
                    </li>
                    <li>
                        De studie of opleiding kost minstens € 20.000 per jaar, exclusief het levensonderhoud.
                    </li>
                    <li>
                        Het kind is op het moment van de schenking tussen de 18 en 40 jaar of heeft een partner tussen
                        de 18 en
                        40 jaar. De dag van de 40e verjaardag telt nog mee.
                    </li>
                    <li>
                        Het kind heeft niet eerder een verhoogde vrijstelling gebruikt voor een schenking van de
                        ouder(s).
                        Hiermee bedoelen we een belastingvrije schenking voor de eigen woning óf een belastingvrije
                        schenking
                        voor een dure studie óf een belastingvrije schenking voor een vrij te besteden doel.
                    </li>
                    <li>
                        Een notaris heeft de schenking vastgelegd in een akte en daarin staat:<br/>
                        - voor welke studie de schenking is bedoeld<br/>
                        - hoe hoog de verwachte kosten van de opleiding zijn<br/>
                        d- at de schenking vervalt als het kind het bedrag niet vóór 2028 heeft besteed aan de opleiding
                    </li>
                    <li>
                        De ouder(s) en het kind kunnen aannemelijk maken dat de schenking is betaald en dat de schenking
                        echt is
                        gebruikt voor de studie. Het kind mag voor de eenmalig verhoogde vrijstelling dus geen
                        gebruikmaken van
                        een schenking op papier.
                    </li>
                    <li>
                        Het kind mag de schenking niet gebruiken om studieschulden af te lossen die zijn ontstaan
                        voordat het de
                        schenking van de ouder(s) kreeg.
                    </li>
                </ul>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB4" aria-expanded="false" aria-controls="collapseB4">
                Vrijstelling voor kwijtschelding van oninbare vordering
            </button>
        </h2>
        <div id="collapseB4" class="accordion-collapse collapse" aria-labelledby="headingB4"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                Als een schuldeiser een oninbare vordering kwijtscheldt – bijvoorbeeld omdat de schuldenaar aantoonbaar
                niet kan betalen – wordt dit onder omstandigheden niet als schenking belast. De Belastingdienst
                beschouwt de kwijtschelding dan niet als bevoordeling, mits er sprake is van afboeking op zakelijke
                gronden en dit voldoende wordt onderbouwd.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB5" aria-expanded="false" aria-controls="collapseB5">
                Vrijstelling bij voldoen aan natuurlijke verbintenis
            </button>
        </h2>
        <div id="collapseB5" class="accordion-collapse collapse" aria-labelledby="headingB5"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                Een schenking wordt niet belast als deze wordt gedaan ter voldoening aan een natuurlijke verbintenis,
                zoals het onderhouden van een kind of het vergoeden van schade. Er moet sprake zijn van een morele of
                maatschappelijke verplichting die zodanig sterk is, dat betaling niet als bevoordeling wordt gezien. Dit
                vereist een goede onderbouwing en beoordeling per situatie.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB6" aria-expanded="false" aria-controls="collapseB6">
                Vrijstelling voor ANBI’s en SBBI’s
            </button>
        </h2>
        <div id="collapseB6" class="accordion-collapse collapse" aria-labelledby="headingB6"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                Giften aan een <b>ANBI</b> (Algemeen Nut Beogende Instelling) of een <b>SBBI</b> (Sociaal Belang
                Behartigende Instelling) zijn vrijgesteld van schenkbelasting, mits de instelling correct is
                geregistreerd bij de Belastingdienst. De schenking mag geen tegenprestatie bevatten. Voor ANBI’s geldt
                dat minimaal 90% van de inzet het algemeen nut moet dienen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB7" aria-expanded="false" aria-controls="collapseB7">
                Vrijstelling wegens samenloop met inkomstenbelasting
            </button>
        </h2>
        <div id="collapseB7" class="accordion-collapse collapse" aria-labelledby="headingB7"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                In sommige situaties zou een schenking kunnen leiden tot dubbele belastingheffing: zowel bij de
                inkomstenbelasting als bij de schenkbelasting. Om dat te voorkomen, is er een vrijstelling als de
                ontvangen waarde reeds is belast als inkomen bij de ontvanger. Denk aan belast loon of belastbare
                periodieke uitkering. De schenking telt dan niet nogmaals mee voor de schenkbelasting.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB8" aria-expanded="false" aria-controls="collapseB8">
                Vrijstelling voor nabestaanden van een werknemer
            </button>
        </h2>
        <div id="collapseB8" class="accordion-collapse collapse" aria-labelledby="headingB8"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                Als een werkgever na overlijden van een werknemer een overlijdensuitkering aan de nabestaanden
                verstrekt, is deze onder voorwaarden vrijgesteld van schenkbelasting. De vrijstelling geldt voor
                uitkeringen tot maximaal driemaal het maandloon van de werknemer. Hogere bedragen kunnen wel belast
                worden, tenzij sprake is van bijzondere sociale omstandigheden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingB1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseB1" aria-expanded="false" aria-controls="collapseB1">
                Bedrijfsopvolgingsvrijstelling (BOR)
            </button>
        </h2>
        <div id="collapseB1" class="accordion-collapse collapse" aria-labelledby="headingB1"
             data-bs-parent="#accordionVrijstellingenSpeciaal">
            <div class="accordion-body">
                De bedrijfsopvolgingsvrijstelling (BOR) geldt bij schenking of vererving van een (familie)bedrijf. In
                2025 is onder voorwaarden tot € 1.500.000 aan ondernemingsvermogen volledig vrijgesteld; over het
                meerdere geldt een 70%-vrijstelling. Voorwaarden zijn o.a. dat het bedrijf minstens 5 jaar wordt
                voortgezet en dat het een reëel actief bedrijf betreft (geen beleggingsonderneming). De BOR is bedoeld
                om bedrijfsopvolging fiscaal te versoepelen.
            </div>
        </div>
    </div>
</div>

